module.exports = __webpack_public_path__ + "static/WhatsApp-4265adef7e7f8d18d6daae51e9664d20.png";